import { c as _c } from "react/compiler-runtime";
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { MdWarning } from 'react-icons/md';
import { PopoverArrow, PopoverBody, PopoverContent, PopoverHeader, PopoverRoot, PopoverTrigger } from '@/components/ui/popover';
import { NodeWarning } from './nodeWarning';
export type NodeWarningBadgeProps = {
  variableName: string;
  warnings: NodeWarning[];
  onSilence?: (warning: NodeWarning) => Promise<void> | void;
};

// Presentation-only (no tRPC) so it renders in Storybook and inside the
// memoized VariableWithBarChart; the silence mutation is wired by the caller
// (see useSilenceNodeWarning).
export default function NodeWarningBadge(t0) {
  const $ = _c(21);
  const {
    variableName,
    warnings,
    onSilence
  } = t0;
  if (warnings.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      placement: "top"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `warnings-${variableName}`;
  const t3 = `${warnings.length} warning${warnings.length === 1 ? "" : "s"}`;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MdWarning style={{
      display: "inline-block",
      verticalAlign: "-1px"
    }} />;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t2 || $[3] !== t3) {
    t5 = <PopoverTrigger asChild={true}><Box aria-label={t2} backgroundColor="orange.500" borderRadius="50%" color="white" cursor="pointer" fontSize="10px" h="14px" lineHeight="14px" textAlign="center" title={t3} w="14px" onClick={_temp} onDoubleClick={_temp2} onMouseDown={_temp3}>{t4}</Box></PopoverTrigger>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <PopoverArrow />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== variableName) {
    t7 = <PopoverHeader fontSize="sm" fontWeight="bold">Warnings on {variableName}</PopoverHeader>;
    $[6] = variableName;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== onSilence || $[9] !== warnings) {
    let t9;
    if ($[11] !== onSilence) {
      t9 = warning => <Flex key={warning.id} align="flex-start" direction="column" gap={1}><Text fontSize="xs">{warning.message}</Text>{onSilence && <Button alignSelf="flex-end" size="xs" title="Approve the current distinguished state and hide this warning" variant="outline" onClick={() => onSilence(warning)}>Silence</Button>}</Flex>;
      $[11] = onSilence;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    t8 = warnings.map(t9);
    $[8] = onSilence;
    $[9] = warnings;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <PopoverBody><Flex direction="column" gap={3}>{t8}</Flex></PopoverBody>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t9) {
    t10 = <PopoverContent maxW="320px">{t6}{t7}{t9}</PopoverContent>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t5) {
    t11 = <PopoverRoot positioning={t1}>{t5}{t10}</PopoverRoot>;
    $[18] = t10;
    $[19] = t5;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}
function _temp3(e_1) {
  return e_1.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}